<script lang="ts">
	import CampfireParts from "@components/CampfireParts.svelte";
	import CartSummary from "@components/CartSummary.svelte";
	import ProductStructuredData from "@components/ProductStructuredData.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import AboutUs from "@components/sections/AboutUs.svelte";
	import Blog from "@components/sections/Blog.svelte";
	import BuyCampfire from "@components/sections/BuyCampfire.svelte";
	import Features from "@components/sections/Features.svelte";
	import FrequentlyAskedQuestions from "@components/sections/FrequentlyAskedQuestions.svelte";
	import Hero from "@components/sections/Hero.svelte";
	import Reviews from "@components/sections/Reviews.svelte";
	import Steps from "@components/sections/Steps.svelte";
	import TargetGroups from "@components/sections/TargetGroups.svelte";
	import { cartDialogState } from "../state/cartDialogState.svelte.js";
	import type { HomepageProps } from "./HomepageProps.js";

	const { news, products }: HomepageProps = $props();
	const [campfire] = products;
</script>

<Layout useTransparentMenu={!cartDialogState.value.open}>
	{#if campfire}
		<ProductStructuredData product={campfire} />
	{/if}

	<Hero />
	<Features />
	<TargetGroups />
	<CampfireParts />
	<Steps />
	<Reviews />
	<BuyCampfire {products} />
	<FrequentlyAskedQuestions />
	<Blog {news} title="Mohlo by vás zajímat" />
	<AboutUs />

	<CartSummary linkToCart />
</Layout>
